
import { useEffect, useState } from 'react'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'
import url from '../api/url'
import { elToast } from '../functions/Alerta'
import { useParams } from 'react-router-dom'
import { diferenciaEnDias } from '../functions/formatearFecha'

export default function useModalAsignarVacaciones(handleClose) {

    const { id: idEmpleadoVacaciones } = useParams()
    const { URL: URL_MIO } = url()
    const setListaVacacionesEmpleado = useEmpleadoStore(state => state.setListaVacacionesEmpleado)
    const editarVacacionesEmpleado = useEmpleadoStore(state => state.editarVacacionesEmpleado)
    const setEditarVacacionesEmpleado = useEmpleadoStore(state => state.setEditarVacacionesEmpleado)
    const setCargandoVacacionesEmpleado = useEmpleadoStore(state => state.setCargandoVacacionesEmpleado)
    const setDiasVacaciones = useEmpleadoStore(state => state.setDiasVacaciones)
    const setDiasVacacionesSumados = useEmpleadoStore(state => state.setDiasVacacionesSumados)
    const vacationsYear = useEmpleadoStore(state => state.vacationsYear)
    const [editarForm, setEditar] = useState(false)
	const [cantidadDeDias, setCantidadDeDias] = useState(0)

    const [guardando, setGuardando] = useState(false)
    const [cantidad, setCantidad] = useState([
        { inicio: "", fin: "" }
    ])

    const handleClickDelete = (index) => {

        setCantidad(cantidad.filter((_, i) => i !== index))
    }

    const handleChange = (value, index, name) => {

        setCantidad((pv) =>
            pv.map((e, i) => {
                if (i === index) {
                    return {
                        ...e, [name]: value
                    }
                }
                return e
            })
        )

    }

    const handleClickAgregar = () => setCantidad(() => [...cantidad, { inicio: "", fin: "" }])

    function listarVacaciones() {

        setCargandoVacacionesEmpleado(true)

        fetch(URL_MIO, {
            method: 'post',
            body: JSON.stringify({
                funcion: 'obtenerVacaciones',
                fk_empleado: idEmpleadoVacaciones,
                vacationsYear
            })
        })
        .then(res => res.json())
        .then(a => {
            let suma = 0;
            a.forEach(e => {
                suma += diferenciaEnDias(e.inicio, e.fin);
            });
            setDiasVacacionesSumados(suma);
            setListaVacacionesEmpleado(a);
        })
        .catch(err => {
            // console.log(err)
            alert('Error al obtener las vacaciones de este empleado')
        })
        .finally(() => {
            setCargandoVacacionesEmpleado(false)
        })
    }

    function obtenerDiasDeVacacionesEmpleado() {

        fetch(URL_MIO, {
            method: 'post',
            body: JSON.stringify({
                funcion: 'obtenerDiasDeVacacionesEmpleado',
                fk_empleado: idEmpleadoVacaciones,
                vacationsYear
            })
        })
        .then(res => res.json())
        .then(a => {
            setDiasVacaciones(a.dias);
        })
        .catch(err => {
            // console.log(err)
            alert('Error al obtener los días de vacaciones de este empleado')
        })
        .finally(() => {
        })
    }


    function guardar() {

        if ( Object.keys(editarVacacionesEmpleado).length > 0 ) {
            // estamos editando
            editar();
            return;
        }

        setGuardando(true)

        // todo: implementar esta cosa
        let body = {
            datos: cantidad,
            fk_empleado: idEmpleadoVacaciones,
            funcion: 'insertarVacaciones'
        }

        fetch( URL_MIO, {
            method: 'post',
            body: JSON.stringify( body )
        })
        .then( res => res.json() )
        .then( r => {

            // eslint-disable-next-line
            if ( r.tipo == 1 ) {
                // alerta success
                elToast('Vacaciones registradas exitosamente', 'success')
                listarVacaciones()
                handleClose()
                // eslint-disable-next-line
            } else if( r.tipo == 2) {
                // alerta success
                elToast(r.mensaje, 'info')
            } else {
                // alerta success
                elToast(r.mensaje, 'error')
            }
        })
        .catch( a => {
            // console.log(a);
        })
        .finally(() => setGuardando(false))
    }

    function editar() {

        setGuardando(true)

        let body = {
            datos: cantidad[0],
            fk_empleado: idEmpleadoVacaciones,
            funcion: 'editarVacacionesEmpleado',
            id: editarVacacionesEmpleado.id
        }

        fetch( URL_MIO, {
            method: 'post',
            body: JSON.stringify( body )
        })
        .then( res => res.json() )
        .then( r => {
            // eslint-disable-next-line
            if ( r.tipo == 1 ) {
                // alerta success
                elToast('Vacaciones editadas exitosamente', 'success')
                listarVacaciones()
                setEditar(false)
                handleClose()
                setEditarVacacionesEmpleado({})
                // eslint-disable-next-line
            } else if( r.tipo == 2) {
                // alerta success
                elToast(r.mensaje, 'info')
            } else {
                // alerta success
                elToast(r.mensaje, 'error')
            }
        })
        .catch( a => {
            // console.log(a);
        })
        .finally(() => setGuardando(false))
    }


    useEffect(() => {
        listarVacaciones()
        obtenerDiasDeVacacionesEmpleado()
        // eslint-disable-next-line
    }, [vacationsYear])


    useEffect(() => {
        if ( Object.keys(editarVacacionesEmpleado).length > 0 ) {
            setCantidad([
                {
                    inicio: editarVacacionesEmpleado.inicio,
                    fin: editarVacacionesEmpleado.fin
                }
            ])
            setEditar(true)
        } else {
            setEditar(false)
        }
        // eslint-disable-next-line
    }, [editarVacacionesEmpleado])


	useEffect(() => {

		if ( cantidad.length > 0 ) {
			const diferencia = diferenciaEnDias(cantidad[0].inicio, cantidad[0].fin)
			setCantidadDeDias(diferencia)
		}
		// eslint-disable-next-line
	}, [cantidad])




    return {
        cantidad, setCantidad, handleClickDelete, handleChange, handleClickAgregar,
        guardar, idEmpleadoVacaciones, guardando, editarForm, cantidadDeDias
    }
}

